import React, { useContext } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Grid,
  Text,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import { useMutation } from '@apollo/client';
import * as Yup from 'yup';
import get from 'lodash/get';

import Input from '../../../components/Input';
import { UPDATE_DROPPOINT_ADDRESS } from '../query';
import UserContext from '../../../contexts/UserContext';
import SpinnerContext from '../../../contexts/SpinnerContext';
import { useCustomToast } from '../../../hooks/useCustomToast';

const Schema = Yup.object().shape({
  street: Yup.string().required('Das ist ein Pflichtfeld'),
  houseNumber: Yup.string().required('Das ist ein Pflichtfeld'),
  postalCode: Yup.string().required('Das ist ein Pflichtfeld'),
  city: Yup.string().required('Das ist ein Pflichtfeld'),
});

const EditDropPointAddressModal = ({ isOpen, onClose, refetch, dropPointId, address }) => {
  const [updateAddress] = useMutation(UPDATE_DROPPOINT_ADDRESS);
  const { toggleSpinner } = useContext(SpinnerContext);
  const { user: internalUser } = useContext(UserContext);
  const toast = useCustomToast();

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>DropPoint-Adresse bearbeiten</ModalHeader>
        <Formik
          initialValues={{
            street: address?.street || '',
            houseNumber: address?.houseNumber || '',
            postalCode: address?.postalCode || '',
            city: address?.city || '',
          }}
          validationSchema={Schema}
          enableReinitialize
          onSubmit={async ({ street, houseNumber, postalCode, city }) => {
            toggleSpinner(true);
            try {
              await updateAddress({
                variables: {
                  dropPointId,
                  street,
                  houseNumber,
                  postalCode,
                  city,
                  internalUserId: internalUser?.id,
                },
              });
              await refetch();
              toast({
                title: 'Erfolg!',
                description: 'Die DropPoint-Adresse wurde geocodiert und gespeichert.',
                status: 'success',
              });
              onClose();
            } catch (error) {
              toast({
                description: get(error, 'graphQLErrors.0.message', 'Ein Fehler ist aufgetreten!'),
                status: 'error',
              });
            }
            toggleSpinner(false);
          }}
        >
          {({ isSubmitting }) => (
            <Form>
              <ModalCloseButton />
              <ModalBody>
                <Text fontSize="sm" color="gray.500" mb="4">
                  Die Adresse wird neu geocodiert. Die Koordinaten werden für Karte und UPS-Export verwendet.
                </Text>
                <Grid templateColumns="2fr 1fr" gap="3">
                  <Input name="street" label="Straße" />
                  <Input name="houseNumber" label="Hausnummer" />
                </Grid>
                <Grid templateColumns="1fr 2fr" gap="3" mt="3">
                  <Input name="postalCode" label="PLZ" />
                  <Input name="city" label="Stadt" />
                </Grid>
              </ModalBody>
              <ModalFooter>
                <Button variant="ghost" mr="3" onClick={onClose}>
                  Abbrechen
                </Button>
                <Button colorScheme="brand" type="submit" isLoading={isSubmitting}>
                  Speichern
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalContent>
    </Modal>
  );
};

export default EditDropPointAddressModal;
